import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from './Button';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { ButtonIcon } from './ButtonIcon';

const Wrapper = styled.div<{ $open: boolean }>`
  --width: 300px;
  background: ${(props) => props.theme.color.greyDark};
  display: flex;
  flex-direction: row;
  width: 100vw;
  max-width: var(--width);
  position: fixed;
  z-index: 1;
  top: 0;
  bottom: 0;
  right: 0;
  clip-path: polygon(15% 0%, 100% 0%, 100% 100%, 0% 100%);
  margin-right: ${(props) => (props.$open ? '0' : 'calc(var(--width) * -1)')};
  transition: margin 0.3s ease-in-out;
`;
const ShapeLeft = styled.div`
  display: flex;
  width: 15%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${(props) => `2${props.theme.unit}`};
  padding: ${(props) =>
    `13${props.theme.unit} 2${props.theme.unit} 2${props.theme.unit} 2${props.theme.unit}`};
`;

export const Menu = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const navigate = useNavigate();

  const redirect = useCallback(
    (path: string) => {
      onClose();
      navigate(path);
    },
    [onClose, navigate]
  );

  return (
    <Wrapper $open={open}>
      <ShapeLeft />
      <Content>
        <ButtonIcon
          icon="draft"
          color="grey"
          onClick={() => {
            redirect('/draft/list');
          }}
        >
          <FormattedMessage id={'draftList'} />
        </ButtonIcon>
        <ButtonIcon
          icon="logs"
          color="grey"
          onClick={() => {
            redirect('/draft/logs');
          }}
        >
          <FormattedMessage id={'draftLogs'} />
        </ButtonIcon>
        <ButtonIcon
          icon="inbox"
          color={'grey'}
          onClick={() => {
            redirect('/contact');
          }}
        >
          <FormattedMessage id="contact" />
        </ButtonIcon>
        <Button
          color={'yellow'}
          onClick={() => {
            redirect('/draft/create');
          }}
        >
          <FormattedMessage id="create" />
        </Button>
      </Content>
    </Wrapper>
  );
};
